// @flow
import React, { Component } from "react";
import classNames from "classnames";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import WarningIcon from "@material-ui/icons/Warning";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../../global/types/GeneralTypes";
import type { ButtonStylesClassesType } from "../../../global/styles/buttonStyles";
import type { DrawerStylesClassesType } from "../../../global/styles/generalStyles";
import type { PersonType } from "../../types/PersonTypes";
import { drawerStyles, formText } from "../../../global/styles/generalStyles";
import { buttonStyles } from "../../../global/styles/buttonStyles";
import { LoadingProgress } from "imagus-components";
import PeopleItem from "./PeopleItem";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...drawerStyles(theme),
  ...buttonStyles(theme),
  formText,
  buttonWidth: {
    width: "96%"
  },
  topMargin: {
    marginTop: "5px"
  }
});

type PeopleListClassesType = {
  ...DrawerStylesClassesType,
  ...ButtonStylesClassesType,
  formText: DictionaryType,
  buttonWidth: DictionaryType,
  topMargin: DictionaryType
};

type PeopleListPropsType = {
  classes: PeopleListClassesType,
  open: boolean,
  checkedIds: Array<string>,
  selectedId: string,
  fetchPeople: Function,
  selectPerson: Function,
  handleToggle: Function,
  updating: { [key: string]: * },
  people: Array<*>,
  showMore: boolean,
  searchQuery: string
};

type PeopleListStatesType = {
  loading: boolean
};

class PeopleList extends Component<PeopleListPropsType, PeopleListStatesType> {
  constructor(props: PeopleListPropsType) {
    super(props);
    this.state = {
      loading: false
    };
  }

  componentDidMount() {
    this.setState({ loading: true });
    this.props.fetchPeople(
      undefined,
      undefined,
      undefined,
      undefined,
      this.finishFetching
    );
  }

  shouldComponentUpdate(nextProps: PeopleListPropsType): boolean {
    if (
      (this.props.updating.fetchingPeople > 0 &&
        nextProps.updating.fetchingPeople > 0) ||
      (this.props.updating.creating > 0 && nextProps.updating.creating > 0) ||
      (this.props.updating.editing > 0 && nextProps.updating.editing > 0)
    ) {
      return false;
    }
    return true;
  }

  scrollListener = (e: SyntheticInputEvent<*>): * => {
    const elm = e.target;
    if (
      elm.scrollTop === elm.scrollHeight - elm.offsetHeight &&
      this.props.showMore
    ) {
      this.loadMore();
    }
  };

  loadMore = (): * => {
    if (!this.state.loading) {
      this.setState({ loading: true });
      this.props.fetchPeople(
        this.props.searchQuery,
        undefined,
        undefined,
        this.props.people[this.props.people.length - 1].uid,
        this.finishFetching,
        true
      );
    }
  };

  finishFetching = () => {
    this.setState({ loading: false });
  };

  render(): * {
    const { classes, selectedId, open, checkedIds } = this.props;

    let people =
      this.props.people &&
      this.props.people.map((person: PersonType, i: number): * => {
        return (
          <PeopleItem
            key={person.uid + "-" + i}
            person={person}
            open={open}
            selectedId={selectedId}
            isChecked={checkedIds.indexOf(person.uid) !== -1}
            selectPerson={this.props.selectPerson}
            handleToggle={this.props.handleToggle}
          />
        );
      });

    if (people.length === 0) {
      people = (
        <ListItem>
          <ListItemIcon>
            <WarningIcon />
          </ListItemIcon>
          <ListItemText primary="No People Found" />
        </ListItem>
      );
    }

    return (
      <List className={classes.list} onScroll={this.scrollListener}>
        {people}
        {this.props.showMore && !this.state.loading && (
          <Button
            color="primary"
            variant="contained"
            type="button"
            id="loadMoreBtn"
            className={classNames(
              classes.lightBtn,
              classes.buttonWidth,
              !open && classes.hide
            )}
            onClick={this.loadMore}
          >
            Load More
          </Button>
        )}
        {this.state.loading && (
          <div className={classNames(classes.topMargin, classes.formText)}>
            <LoadingProgress size={60} />
          </div>
        )}
      </List>
    );
  }
}

export default withStyles(styles)(PeopleList);
